import { Link } from "react-router-dom";
import { SERVICE_PAGES, SEO_PAGE_ADMIN_LABELS } from "../../data/servicePages";
import { resolveMediaUrl } from "../../lib/api";
import { SocialLinks } from "./SocialLinks";

export const Footer = ({ brandName, logoUrl, socialInstagram, socialFacebook }) => {
  return (
    <footer data-testid="site-footer" className="bg-black border-t border-white/10 py-16">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div className="flex flex-col gap-4">
          <div className="flex items-center gap-3">
            {logoUrl && <img src={resolveMediaUrl(logoUrl)} alt={brandName} className="h-9 w-9 rounded-full object-cover" />}
            <span className="font-serif-display text-lg text-white">{brandName}</span>
          </div>
          <p className="text-xs uppercase tracking-[0.2em] text-white/40">
            Fotografía &amp; Video · Querétaro, México
          </p>
        </div>

        <div data-testid="footer-services-links" className="flex flex-col gap-3">
          <p className="text-white/40 text-xs uppercase tracking-[0.25em] mb-1">Servicios</p>
          {SERVICE_PAGES.map((p) => (
            <Link
              key={p.slug}
              to={p.slug}
              data-testid={`footer-services-link-${p.slug.replace(/\//g, "")}`}
              className="text-white/60 text-sm hover:text-twp-gold transition-colors"
            >
              {SEO_PAGE_ADMIN_LABELS[p.pageId]}
            </Link>
          ))}
        </div>

        <div className="flex flex-col gap-3">
          <p className="text-white/40 text-xs uppercase tracking-[0.25em] mb-1">Contacto</p>
          <Link to="/#contacto" data-testid="footer-contact-link" className="text-white/60 text-sm hover:text-twp-gold transition-colors">
            Contáctanos
          </Link>
          <SocialLinks instagram={socialInstagram} facebook={socialFacebook} className="mt-2" />
          <p data-testid="footer-copyright" className="text-xs text-white/30 mt-4">
            © {new Date().getFullYear()} {brandName}. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};
